import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { Inline } from '../../../../../../Components/CustomUi/inline'
import Input from '../../../../../../Components/CustomUi/input'
import KMLUploader from '../../../../../../Components/kmlUpload'
import {
  faChevronLeft,
  faChevronRight,
  faHashtag,
  faPlus,
  faRotate,
} from '@fortawesome/free-solid-svg-icons'
import { Collapse, Slider } from 'antd'
import { GridMalha } from '../../gerarMalha'
import { useEffect } from 'react'
import { errorAlert, loadingAlert } from '../../../../../../utils/alert'
import { gerarGrid } from '../../../meta'
import * as turf from '@turf/turf'
import { Warning } from '../../../../../../Components/CustomUi/warning'

interface PropsMapa {
  handleFileUpload: (rawData: string, base64Data: string) => void
  validoFile: boolean
  rotation: number
  setRotation: React.Dispatch<React.SetStateAction<number>>
  rotacaoInput: string
  setRotacaoInput: React.Dispatch<React.SetStateAction<string>>
  gridLevel: string
  setGridLevel: React.Dispatch<React.SetStateAction<string>>
  position: { x: 0; y: 0 }
  setPosition: React.Dispatch<React.SetStateAction<{ x: number; y: number }>>
  movendo: boolean
  setMovendo: React.Dispatch<React.SetStateAction<boolean>>
  loading: string
  setLoading: React.Dispatch<React.SetStateAction<string>>
  tab_container_atual: string
  setTab_container_atual: React.Dispatch<React.SetStateAction<string>>
  novoPonto: boolean
  setNovoPonto: React.Dispatch<React.SetStateAction<boolean>>
  moverPonto: boolean
  setMoverPonto: React.Dispatch<React.SetStateAction<boolean>>
  removerPonto: boolean
  setRemoverPonto: React.Dispatch<React.SetStateAction<boolean>>
  setGrid: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setGridOriginal: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setGridOriginalRotacao: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setTamanhoGridOriginal: React.Dispatch<React.SetStateAction<number>>
  setQuadrante: React.Dispatch<React.SetStateAction<number>>
  areaHectares: number
  polygon: turf.Feature
  grid: GridMalha[]
  area: any[]
  abaAtual: number
  abasNome: any[]
  kmlComCruzamento: boolean
}

export const AbaMapa: React.FC<PropsMapa> = ({
  handleFileUpload,
  validoFile,
  rotation,
  setRotation,
  rotacaoInput,
  setRotacaoInput,
  gridLevel,
  setGridLevel,
  position,
  setPosition,
  movendo,
  setMovendo,
  loading,
  setLoading,
  tab_container_atual,
  setTab_container_atual,
  moverPonto,
  setMoverPonto,
  novoPonto,
  setNovoPonto,
  removerPonto,
  setRemoverPonto,
  setGrid,
  setGridOriginal,
  setGridOriginalRotacao,
  setTamanhoGridOriginal,
  setQuadrante,
  areaHectares,
  polygon,
  area,
  grid,
  abaAtual,
  abasNome,
  kmlComCruzamento,
}) => {
  const { Panel } = Collapse

  function adicionar(valor) {
    setMovendo(true)
    setRotation(valor + 1)
    setRotacaoInput(String(valor + 1))
  }

  function diminuir(valor) {
    setMovendo(true)
    setRotation(valor - 1)
    setRotacaoInput(String(valor - 1))
  }

  const valorDaRotacao = (e) => {
    const entrada = e

    // Permitir: vazio, "-" (usuário começando digitação), número válido
    if (entrada === '' || entrada === '-' || /^-?\d*\.?\d*$/.test(entrada)) {
      const num = parseFloat(entrada)

      if (isNaN(num)) {
        setRotacaoInput(entrada)
      } else {
        if (num >= -180 && num <= 180) {
          setRotacaoInput(entrada)
        } else {
          errorAlert('Limite excedido de rotação! limite é de -180 a 180')
        }
      }
    }
  }

  function tranformarEmNumber(valor: string): number | null {
    const normalizado = valor
      .trim()
      .replace(',', '.')
      .replace(/[^\d.-]/g, '')
      
    const numeroValido = /^-?\d+(\.\d+)?$/.test(normalizado)
    if (!numeroValido) return null

    const numero = Number(normalizado)
    return isNaN(numero) ? null : numero
  }

  function esconderMalha(cod) {
    const aba = cod[0]
    if (aba !== undefined) {
      setMovendo(true)
    }
  }

  function handleChange(valor) {
    let entrada = valor;

    // Substitui vírgula por ponto
    entrada = entrada.replace(",", ".");

    // Permite apenas números e ponto decimal (uma vez)
    if (/^\d*\.?\d*$/.test(entrada)) {
      setGridLevel(entrada);
    }
  }

  useEffect(() => {
    if (rotacaoInput !== null) {
      const numero = tranformarEmNumber(rotacaoInput)
      setRotation(numero === null ? 0 : numero)
    } 
    
    if (rotacaoInput === null) {
      setRotation(0)
    }

  }, [rotacaoInput])

  useEffect(() => {
    if (movendo) {
      setRotacaoInput(String(rotation))
    }
  }, [rotation])

  useEffect(() => {
    if (loading === 'l') {
      loadingAlert({ msg: 'Gerando grid...', id: 'loading' })
      setTimeout(() => {
        setLoading('g')
      }, 300)
    }

    if (loading === 'g') {
      gerarGrid(
        Number(gridLevel),
        polygon,
        areaHectares,
        setGrid,
        setGridOriginal,
        setGridOriginalRotacao,
        setTamanhoGridOriginal,
        setLoading,
        setQuadrante
      )
    }
  }, [loading])

  return (
    <>
      <KMLUploader
        onFileUpload={handleFileUpload}
        valido={validoFile}
      ></KMLUploader>

      <Inline>
        <Input
          label='Tamanho do grid'
          placeholder={''}
          value={gridLevel}
          onChange={handleChange}
          icon={faHashtag}
          desabilitado={area.length <= 0 || kmlComCruzamento}
        />
        <ButtonCustom
          onClick={() => setLoading('l')}
          style={{ marginTop: '30px' }}
          icon={<FontAwesomeIcon icon={faPlus} />}
          disabled={area.length <= 0 || kmlComCruzamento}
          loading={loading === 'l'}
        >
          Gerar
        </ButtonCustom>
      </Inline>

      <div
        onMouseEnter={() => setMovendo(true)}
        onMouseLeave={() => setMovendo(false)}
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
      >
        <Collapse accordion destroyInactivePanel onChange={esconderMalha}>
          <Panel header={'Rotação'} key={1}>
            <Input
              placeholder={'Digite a rotação'}
              value={rotacaoInput}
              onChange={(e) => valorDaRotacao(e)}
              max={180}
              min={-180}
              desabilitado={grid.length <= 0 || kmlComCruzamento}
              icon={faRotate}
            />
            <Slider
              min={-180}
              max={180}
              step={1}
              value={rotation}
              onChange={(e) => {
                setRotation(e)
                // começou a usar
              }}
              style={{ width: '98%' }}
              disabled={grid.length <= 0 || kmlComCruzamento}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ display: 'flex', gap: 5 }}>
                <ButtonCustom
                  style={{
                    width: '20px',
                    height: '30px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  onClick={() => diminuir(rotation)}
                  icon={<FontAwesomeIcon icon={faChevronLeft} />}
                  disabled={grid.length <= 0 || kmlComCruzamento}
                />
                <ButtonCustom
                  style={{
                    width: '20px',
                    height: '30px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  onClick={() => adicionar(rotation)}
                  icon={<FontAwesomeIcon icon={faChevronRight} />}
                  disabled={grid.length <= 0 || kmlComCruzamento}
                />
              </div>
            </div>
          </Panel>
          <Panel header={'Posicionar'} key={2}>
            <div>
              <span style={{ fontSize: '12px' }}>Horizontal:</span>
              <Slider
                min={-360}
                max={360}
                step={1}
                value={position.x}
                onChange={(value) => {
                  setPosition((prev) => ({ ...prev, x: value as number }))
                }}
                disabled={grid.length <= 0 || kmlComCruzamento}
              />
            </div>
            <div>
              <span style={{ fontSize: '12px' }}>Vertical:</span>
              <Slider
                min={-360}
                max={360}
                step={1}
                value={position.y}
                onChange={(value) => {
                  setPosition((prev) => ({ ...prev, y: value as number }))
                }}
                disabled={grid.length <= 0 || kmlComCruzamento}
              />
            </div>
          </Panel>
        </Collapse>
        <Warning style={{ fontSize: 11 }} type='info'>
          Ao rotacionar ou posicionar, a malha será temporariamente ocultada para otimizar a
          visualização.
        </Warning>
      </div>
    </>
  )
}